var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m-dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.261,
    height: 18.273,
    viewBox: "0 0 18.261 18.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43085",
    "data-name": "Caminho 43085",
    d: "M8.929,4.47a17.516,17.516,0,0,0-3.858,0,.666.666,0,0,0-.587.576,16.816,16.816,0,0,0,0,3.907.666.666,0,0,0,.587.576,17.516,17.516,0,0,0,3.858,0,.666.666,0,0,0,.587-.576,16.816,16.816,0,0,0,0-3.907A.666.666,0,0,0,8.929,4.47ZM4.9,2.98a19.017,19.017,0,0,1,4.192,0,2.166,2.166,0,0,1,1.911,1.893,18.322,18.322,0,0,1,0,4.256A2.166,2.166,0,0,1,9.1,11.021a19.023,19.023,0,0,1-4.192,0,2.166,2.166,0,0,1-1.91-1.893,18.316,18.316,0,0,1,0-4.256A2.166,2.166,0,0,1,4.9,2.98Z",
    transform: "translate(-2.87 -2.864)",
    fill: "#0f1824",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43086",
    "data-name": "Caminho 43086",
    d: "M8.929,14.47a17.514,17.514,0,0,0-3.858,0,.666.666,0,0,0-.587.576,16.816,16.816,0,0,0,0,3.907.666.666,0,0,0,.587.576,17.526,17.526,0,0,0,3.858,0,.666.666,0,0,0,.587-.576,16.816,16.816,0,0,0,0-3.907.666.666,0,0,0-.587-.576ZM4.9,12.98a19.023,19.023,0,0,1,4.192,0,2.166,2.166,0,0,1,1.911,1.893,18.322,18.322,0,0,1,0,4.256A2.166,2.166,0,0,1,9.1,21.021a19.023,19.023,0,0,1-4.192,0,2.166,2.166,0,0,1-1.91-1.893,18.316,18.316,0,0,1,0-4.256A2.166,2.166,0,0,1,4.9,12.98Z",
    transform: "translate(-2.87 -2.864)",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43087",
    "data-name": "Caminho 43087",
    d: "M18.929,4.47a17.517,17.517,0,0,0-3.858,0,.666.666,0,0,0-.587.576,16.817,16.817,0,0,0,0,3.907.666.666,0,0,0,.587.576,17.517,17.517,0,0,0,3.858,0,.666.666,0,0,0,.587-.576,16.817,16.817,0,0,0,0-3.907A.666.666,0,0,0,18.929,4.47ZM14.9,2.98a19.017,19.017,0,0,1,4.192,0,2.166,2.166,0,0,1,1.91,1.893,18.322,18.322,0,0,1,0,4.256,2.166,2.166,0,0,1-1.91,1.893,19.023,19.023,0,0,1-4.192,0,2.166,2.166,0,0,1-1.91-1.893,18.311,18.311,0,0,1,0-4.256A2.166,2.166,0,0,1,14.9,2.98Z",
    transform: "translate(-2.87 -2.864)",
    fill: "#a6abaf",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_43088",
    "data-name": "Caminho 43088",
    d: "M18.929,14.47a17.514,17.514,0,0,0-3.858,0,.666.666,0,0,0-.587.576,16.817,16.817,0,0,0,0,3.907.666.666,0,0,0,.587.576,17.527,17.527,0,0,0,3.858,0,.666.666,0,0,0,.587-.576,16.817,16.817,0,0,0,0-3.907.666.666,0,0,0-.587-.576ZM14.9,12.98a19.023,19.023,0,0,1,4.192,0,2.166,2.166,0,0,1,1.91,1.893,18.322,18.322,0,0,1,0,4.256,2.166,2.166,0,0,1-1.91,1.893,19.023,19.023,0,0,1-4.192,0,2.166,2.166,0,0,1-1.91-1.893,18.311,18.311,0,0,1,0-4.256A2.166,2.166,0,0,1,14.9,12.98Z",
    transform: "translate(-2.87 -2.864)",
    fill: "#0f1824",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMDashboard);
export default __webpack_public_path__ + "static/media/m-dashboard.09c948b7d630ed653031e9601d6b7f34.svg";
export { ForwardRef as ReactComponent };